import React from 'react';
import _ from 'underscore';
import { Map, Marker, Polygon, DrawingManager } from 'components/maps';

const parsePolygon = (poly) => {
  const paths = [];
  poly
    .getPath()
    .getArray()
    .forEach((point) => {
      paths.push([point.lng(), point.lat()]);
    });
  return paths;
};

const green = '#21B88E';
const blue = '#1384D2';

const staticPolygonOptions = {
  strokeColor: green,
  fillColor: green,
  fillOpacity: 0.6,
  strokeWeight: 2,
  zIndex: 1,
};

const dynamicPolygonOptions = {
  strokeColor: green,
  fillColor: green,
  fillOpacity: 0.4,
  strokeWeight: 3,
  zIndex: 1,
};

const focusPolygonOptions = {
  strokeColor: blue,
  fillColor: blue,
  fillOpacity: 0.4,
  strokeWeight: 3,
  zIndex: 1,
};

const GeofenceMapInner = ({
  location,
  zoom,
  onPolygonComplete,
  onLocationDrag,
  onMapClick,
  latLongs,
  focusLatLongs,
  showMarker,
  canEditPolygon,
  height,
}) => {
  const drawingColor = focusLatLongs ? blue : green;

  const handlePolygonComplete = (polygon) => {
    const coordinates = parsePolygon(polygon);
    coordinates.push(coordinates[0]);
    onPolygonComplete({
      type: 'Polygon',
      coordinates: [[[coordinates]]],
      polygon,
    });
  };

  return (
    <Map
      height={height || 500}
      defaultZoom={zoom || 14}
      zoom={zoom || 14}
      defaultCenter={location}
      center={location}
      options={{
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      }}
      onClick={(event) =>
        onMapClick(event.latLng?.lat() ?? 0, event.latLng?.lng() ?? 0)
      }
    >
      <DrawingManager
        onPolygonComplete={handlePolygonComplete}
        options={{
          drawingControl: true,
          drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: [google.maps.drawing.OverlayType.POLYGON],
          },
          polygonOptions: {
            draggable: true,
            strokeColor: drawingColor,
            fillColor: drawingColor,
            fillOpacity: 0.4,
            strokeWeight: 3,
            clickable: true,
            editable: true,
            zIndex: 1,
          },
        }}
      />
      {showMarker && (
        <Marker
          position={location}
          draggable
          onDrag={(event) =>
            onLocationDrag(event.latLng?.lat() ?? 0, event.latLng?.lng() ?? 0)
          }
        />
      )}
      {!_.isEmpty(latLongs) &&
        latLongs.map((fence) => (
          <Polygon
            key={fence[0].lng}
            options={
              canEditPolygon ? dynamicPolygonOptions : staticPolygonOptions
            }
            path={fence}
          />
        ))}
      {!_.isEmpty(focusLatLongs) &&
        focusLatLongs.map((fence) => (
          <Polygon
            key={fence[0].lng}
            options={focusPolygonOptions}
            path={fence}
          />
        ))}
    </Map>
  );
};

export default class GeofenceMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = { location: props.location };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState({ location: newProps.location });
  }

  render() {
    const { location } = this.state;
    if (!location) return <div />;

    return (
      <div>
        <GeofenceMapInner
          location={location}
          zoom={this.props.zoom}
          height={this.props.height}
          onPolygonComplete={this.props.onPolygonComplete}
          onLocationDrag={this.props.onLocationDrag}
          onMapClick={() => {}}
          latLongs={this.props.latLongs}
          focusLatLongs={this.props.focusLatLongs}
          showMarker={this.props.showMarker}
          canEditPolygon={this.props.canEditPolygon}
        />
      </div>
    );
  }
}
